/* eslint-disable quote-props, max-len */

export default {
  'season': ({ seasonNumber }) => `Staffel ${seasonNumber}`,
  'episode': ({ episodeNumber }) => `Folge ${episodeNumber}`,
  'parentalControl.enterPin': 'Um auf altersbeschränkte Inhalte zugreifen zu können, gib bitte deinen Bestätigungscode ein',
  'adInfo': ({ ads, adsCount }) => `Anzeige ${ads} von ${adsCount}`,
  'visitAd': 'Werbende besuchen',
  'skipAd': 'Überspringen',
  'skipAdInTime': ({ time }) => `Überspringen in ${time}`,
  'chromecast.castingTo': 'Übertrage auf',
  'chromecast.onboardingLabel': 'Übertrage auf deinen Fernseher',
  'playerSettings.audio': 'Audio',
  'playerSettings.subtitles': 'Untertitel',
  'playerSettings.quality': 'Qualität',
  'playerSettings.off': 'Aus',
  'playerSettings.auto': 'Automatisch',
  'playerSettings.high': 'Hoch',
  'playerSettings.medium': 'Mittel',
  'playerSettings.low': 'Niedrig',
  'playerError.noSubscription': 'Die Sendung ist mit deinem TV-Paket nicht verfügbar',
  'playerError.countryPermission': 'Sendung in dieser Region nicht verfügbar',
  'playerError.trafficOverload': "Der Service ist gerade stark überlastet. Versuch's später nochmal.",
  'playerError.upgradeSubscription': 'Die Sendung ist mit deinem TV-Paket nicht verfügbar',
  'playerError.notAvailable': 'Sendung nicht verfügbar',
  'playerError.noLongerAvailable': 'Das Video ist nicht länger verfügbar.',
  'playerError.anotherPlayer': "Du schaust diese Sendung schon in einem anderen Browser, Tab oder Gerät. Schließe sie dort und versuch's nochmal.",
  'playerError.verifyEmail': 'Bestätige deine E-Mail-Adresse, um diese Sendung zu schauen',
  'playerError.parentalControl': 'Video nicht verfügbar wegen Kindersicherung',
  'playerError.wrongPIN': 'Falsche Eingabe. Bitte versuche es nochmals.',
  'playerError.cannotChromecast': 'Streamen über Chromecast nicht möglich',
  'playerError.tooManyDevices': 'Zu viele registrierte Geräte. Setze die Geräte-Liste in den Einstellungen zurück.',
  'playerError.enterPostcode': 'Postleitzahl eingeben',
  'playerError.wrongRegion': 'Dieser Service ist in Deinem Land nicht verfügbar',
  'playerError.noDRM': 'Urheberrechtlich geschütztes Video kann auf diesem Gerät nicht abgespielt werden',
  'playerError.noLiveRights': 'Diese Sendung ist nicht live verfügbar',
  'playerError.browser': 'Ihr Browser kann den Inhalt nicht lesen. Versuchen Sie, Ihren Browser neu zu installieren oder einen anderen zu verwenden.',
  'playerError.adblockerDetected': 'Zur Wiedergabe bitte Werbeblocker deaktivieren oder deine Netzwerkverbindung prüfen',
  'playerError.entitlementUnauthorized': "Sitzung abgelaufen. Logge dich aus und wieder ein und probier's dann nochmal.",
  'playerError.forbiddenProxy': 'Video nicht verfügbar bei Verwendung eines Proxy oder VPN',
  'playerError.licenseRejected': 'Aufgrund von Lizenzbeschränkungen wird dieser Kanal in diesem Browser nicht unterstützt.',
  'playerError.outputRestricted': 'Due to license restrictions, playback is not supported on this display.',
  'playerError.serverError': ({ code }) => `Netzwerkanfrage mit Statuscode ${code} fehlgeschlagen. Bitte versuche es erneut.`,
  'playerError.networkError': 'Netzwerkanfrage abseits des Servers fehlgeschlagen. Bitte versuche es erneut.',
  'playerOverlays.pauseOverlay': 'Die Sendung geht dort weiter, wo sie gerade live ist.',
  'error': "Es ist ein Fehler aufgetreten. Probier's nochmal.",
  'nextVideo.label': 'Nächste Folge',
  'nextVideo.timer': ({ time }) => `in ${time}`,
};
